<template>
  <main-page :user="user" color="blue">
    <template v-slot:title> </template>

    <div class="container-fluid" style="text-align: left">
      <div class="row mt-3">
        <div class="col-sm-3">
          <admin-nav></admin-nav>
        </div>

        <div class="col-sm-9">
          <div class="d-flex flex-row align-items-start">
            <div class="row flex mr-3">
              <div
                class="col-12 col-lg-4 mb-2 d-flex flex-row align-items-center"
              >
                <i
                  v-if="!filter"
                  style="min-width: 15px"
                  class="fas fa-search mx-2"
                />
                <i
                  v-if="filter"
                  style="min-width: 15px; padding-left: 2px; padding-top: 2px"
                  class="fas fa-times mx-2 clickable"
                  @click="filter = ''"
                />
                <input
                  class="form-control listing-search"
                  placeholder="Search users..."
                  v-model="filter"
                />
              </div>
              <div class="form-group col-12 col-lg-4">
                <config-select
                  :options="fs.roleOptions"
                  :nullOption="true"
                  byField="id"
                  v-model="role"
                />
              </div>
              <div class="col-12 col-lg-4 mb-2">
                <config-select
                  :options="districts"
                  :nullOption="true"
                  byField="id"
                  v-model="district_id"
                />
              </div>
            </div>
            <button
              @click="exportItems"
              class="btn btn-primary mr-3"
              v-tippy
              title="Export"
            >
              <i class="fas fa-file-export" />
            </button>
            <a href="/#/users/new" class="btn btn-primary mr-3">New</a>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              style="float: right"
            ></b-pagination>
          </div>
          <b-table
            v-if="districts"
            ref="table"
            :show-empty="true"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template v-slot:cell(district)="data">
              <div v-if="!data.item.district" class="text-very-muted">
                None
              </div>
              <div v-else>{{ data.item.district.name }}</div>
            </template>
            <template v-slot:cell(role)="data">
              {{ fs.roleName(data.item.role) }}
            </template>
            <template v-slot:cell(created)="data">
              {{ fs.medDate(data.item.created) }}
            </template>
            <template v-slot:cell(sections)="data">
              <span
                v-if="data.item.sections && data.item.sections.length > 0"
                v-tippy
                :title="fs.namesListTooltip('Classes', data.item.sections)"
              >
                {{ data.item.sections.length }}
              </span>
              <span
                v-if="!data.item.sections || data.item.sections.length == 0"
                class="text-very-muted"
                >None</span
              >
            </template>
            <template v-slot:cell(actions)="data">
              <div class="d-flex flex-row align-items-center">
                <a
                  :href="`/#/users/${data.item.id}`"
                  class="mr-1 btn btn-inline btn-success"
                  >Edit</a
                >
                <button
                  @click="openLoginAsModal(data.item)"
                  class="mr-1 btn btn-inline btn-primary"
                >
                  Login
                </button>
                <confirm-delete
                  typeName="User"
                  :objectName="fs.displayName(data.item.name)"
                  :objectId="data.item.id"
                  :canDelete="service.canDeleteUser"
                  :delete="service.deleteUser"
                  :cleanup="$refs.table.refresh"
                >
                  <button class="btn btn-inline btn-danger">Delete</button>
                  <template v-slot:cantDeleteMessage>
                    <h3>
                      The User
                      <span class="text-danger _600"
                        >"{{ fs.displayName(data.item.name) }}"</span
                      >
                      cannot be deleted
                    </h3>
                    <div class="mt-3 text-md text-muted">
                      To preserve data integrity, users that have been added to
                      classes are no longer deleteable
                    </div>
                  </template>
                </confirm-delete>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-modal id="loginAsModal">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">You will be logged in as {{ fs.displayName(loginUser.name) }}</h3>
      </template>
      <div v-if="loginUser" class="p-2">
        <h6>
          You will need to log out of this user in order to log in as
          {{ fs.displayName(user.name) }} again.
        </h6>
      </div>
      <template v-slot:modal-footer="{ _, cancel }">
        <button type="button" class="btn btn-primary" @click="loginAs">
          Login
        </button>
        <button type="button" class="btn btn-secondary" @click="cancel">
          Cancel
        </button>
      </template>
    </b-modal>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import ConfigSelect from "@/components/ConfigSelect";
import ConfirmDelete from "@/components/ConfirmDelete";
import AdminService from "@/services/AdminService";
import AuthService from "@/services/AuthService";
import FileService from "@/services/FileService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import Store from "@/services/Store";

export default {
  name: "UserListing",

  props: ["user"],

  components: { MainPage, AdminNav, ConfigSelect, ConfirmDelete },

  data() {
    return {
      fs: fs,
      service: AdminService,
      districts: null,

      loginUser: null,

      filter: Store.get(this, "UserListing.filter"),
      currentPage: 1,
      perPage: 15,
      sortBy: "",
      sortDesc: false,
      totalRows: 1,

      role: Store.get(this, "UserListing.role"),
      district_id: Store.get(this, "UserListing.district_id"),

      fields: [
        { key: "name.last", label: "Last Name", sortable: true },
        { key: "name.first", label: "First Name", sortable: true },
        { key: "district", label: "District", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "role", label: "Role", sortable: true },
        { key: "sections", label: "Classes", sortable: true },
        { key: "created", label: "Created", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },

  watch: {
    filter() {
      Store.set(this, "UserListing.filter", this.filter);
    },

    role() {
      Store.set(this, "UserListing.role", this.role);
      this.$refs.table.refresh();
    },

    district_id() {
      Store.set(this, "UserListing.district_id", this.district_id);
      this.$refs.table.refresh();
    },
  },

  created() {
    this.loadConfig();
  },

  methods: {
    loadConfig() {
      this.service
        .listDistricts({})
        .then((r) => {
          this.districts = r.data.result;
        })
        .catch((e) => {
          console.error(e);
          Notie.error("Failed to load districts", e);
        });
    },

    items() {
      var pageOpts = {
        filter: this.filter,
        // query: query,
        page_size: this.perPage,
        current_page: this.currentPage,
        sort_by: this.sortBy,
        sort_desc: this.sortDesc,
        skip: (this.currentPage - 1) * this.perPage,
      };

      let timestamp = new Date().getTime();
      this.latest = timestamp;
      return new Promise((resolve, reject) => {
        this.service
          .listUsersPrefilled(pageOpts, this.role, this.district_id)
          .then((resp) => {
            if (timestamp != this.latest) {
              console.log("NOT LATEST", timestamp, this.latest);
              return;
            }

            console.log(resp);
            resolve(resp.data.result);
            this.totalRows = resp.data.count;
            this.$forceUpdate();
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    exportItems() {
      var pageOpts = {
        filter: this.filter,
        // query: query,
        page_size: 0,
        current_page: 0,
        sort_by: this.sortBy,
        sort_desc: this.sortDesc,
        skip: 0,
      };

      this.service
        .listUsers(pageOpts, this.role, this.district_id)
        .then((r) => {
          console.log("ALL ITEMS", r.data.result);
          FileService.exportUsers(r.data.result, this.districts);
        })
        .catch((e) => {
          console.error(e);
          Notie.error("Failed to export users", e);
        });
    },

    openLoginAsModal(user) {
      this.loginUser = user;
      this.$bvModal.show("loginAsModal");
    },

    loginAs() {
      AuthService.loginAs(this.loginUser.id)
        .then((resp) => {
          // Successful login, but with redirect message
          if (resp.data) {
            if (resp.data.message == "toDistrictPick") {
              this.$router.push("/district_select");
            } else {
              Notie.error("Unexpected login error");
              console.log("UNEXPECTED LOGIN MESSAGE", resp);
            }
            return;
          }

          // Successful normal login
          let user = resp.user;
          let hash = resp.hash;

          AdminService.getDistrict(user.district_id)
            .then((r) => {
              var path = window.location.origin;
              if (r.data.host) {
                path = r.data.host;
              }

              console.log("LOGIN USER", user);
              if (user.role == "ADMIN") {
                path = path + "/#/admin";
              } else if (user.role == "TEACHER") {
                path = path + "/#/classes";
              } else if (user.role == "JUDGE") {
                if (user.sections && user.sections.length > 1) {
                  path = path + "/#/classes";
                } else {
                  path = path + "/#/pitches";
                }
              } else {
                if (user.sections && user.sections.length == 1) {
                  path = path + "/#/portfolio";
                } else {
                  path = path + "/#/classes";
                }
              }

              if (hash) {
                path = path + "?hash=" + hash;
              }

              window.location.href = path;
            })
            .catch((e) => {
              Notie.error("Could not retrieve district");
              console.log(e);
            });
        })
        .catch((e) => {
          Notie.error("Failed to login as user", e);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
